// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { LanguageProvider } from './context/LanguageContext'; // ✅ أضف هذا
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>

      <LanguageProvider> {/* ✅ غلف التطبيق */}
        <App />
      </LanguageProvider>
    </HelmetProvider>

  </React.StrictMode>
);

reportWebVitals();
